import React from 'react';
import { BrandMark, IconAlert } from './Icons';
import { BRAND_NAME, BRAND_TAGLINE } from './brand';
import { ThemeToggle } from './theme';

export function SiteHeader({ children }) {
  return (
    <header className="site-header">
      <div className="site-header-inner">
        <div className="site-brand">
          <BrandMark size={36} />
          <div className="site-brand-text">
            <span className="site-brand-name">{BRAND_NAME}</span>
            <span className="site-brand-tagline">{BRAND_TAGLINE}</span>
          </div>
        </div>
        <div className="site-header-right">
          {children}
          <ThemeToggle />
        </div>
      </div>
    </header>
  );
}

export function SiteFooter() {
  return (
    <footer className="site-footer">
      © {new Date().getFullYear()} {BRAND_NAME} · {BRAND_TAGLINE}
    </footer>
  );
}

export function StateCard({ icon, tone = 'accent', title, text, action }) {
  return (
    <div className="state-card">
      <div className={`state-icon state-icon-${tone}`}>{icon || <IconAlert size={26} />}</div>
      <h2>{title}</h2>
      {text && <p>{text}</p>}
      {action}
    </div>
  );
}

export function WatchSkeleton({ withSidebar }) {
  return (
    <div className={`watch-layout ${withSidebar ? 'has-sidebar' : ''}`} aria-busy="true" aria-label="Загрузка">
      <div className="watch-player-area">
        <div className="skeleton skeleton-player" />
      </div>
      <div className="watch-info-area">
        <div className="card watch-info">
          <div className="skeleton skeleton-line" style={{ width: '62%', height: 26 }} />
          <div className="skeleton skeleton-line" style={{ width: '36%' }} />
          <div className="skeleton skeleton-line" style={{ width: '90%', marginTop: 18 }} />
          <div className="skeleton skeleton-line" style={{ width: '75%' }} />
        </div>
      </div>
      {withSidebar && (
        <div className="watch-side-area">
          <div className="card playlist-panel">
            {[0, 1, 2, 3].map((i) => (
              <div key={i} className="skeleton skeleton-line" style={{ height: 44, marginBottom: 10 }} />
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
